import Http from '@/api/http.js'

export default {
  
  index(params){
    return Http.get(`/seller_dashboard`, {params});
  },


  
}